import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=64d2aa86"
import script from "./demo2.vue?vue&type=script&lang=js"
export * from "./demo2.vue?vue&type=script&lang=js"
import style0 from "./demo2.vue?vue&type=style&index=0&id=64d2aa86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports